export default __webpack_public_path__ + "static/media/g_szal.d75c2e01.jpg";